import CreateTeamInfo from './CreateTeamInfo';

export default CreateTeamInfo;
